const russianMessages = {
  ra: {
    action: {
      add_filter: 'Добавить фильтр',
      add: 'Добавить',
      back: 'Назад',
      bulk_actions: '%{smart_count} выбрано',
      cancel: 'Отмена',
      clear_array_input: 'Очистить список',
      clear_input_value: 'Очистить',
      clone: 'Клонировать',
      confirm: 'Подтвердить',
      create: 'Создать',
      create_item: 'Создать %{item}',
      delete: 'Удалить',
      edit: 'Редактировать',
      export: 'Экспорт',
      list: 'Список',
      refresh: 'Обновить',
      remove_filter: 'Удалить фильтр',
      remove_all_filters: 'Удалить все фильтры',
      remove: 'Удалить',
      save: 'Сохранить',
      search: 'Поиск',
      select_all: 'Выбрать все',
      select_row: 'Выбрать строку',
      show: 'Показать',
      sort: 'Сортировать',
      undo: 'Отменить',
      unselect: 'Снять выбор',
      expand: 'Развернуть',
      close: 'Закрыть',
      open_menu: 'Открыть меню',
      close_menu: 'Закрыть меню',
      update: 'Обновить',
      move_up: 'Переместить вверх',
      move_down: 'Переместить вниз',
      open: 'Открыть',
      toggle_theme: 'Переключить тему',
      select_columns: 'Выбрать столбцы',
      update_application: 'Обновить приложение',
    },
    boolean: {
      true: 'Да',
      false: 'Нет',
      null: ' ',
    },
    page: {
      create: 'Создать %{name}',
      dashboard: 'Главная',
      edit: '%{name} #%{id}',
      error: 'Что-то пошло не так',
      list: '%{name}',
      loading: 'Загрузка',
      not_found: 'Не найдено',
      show: '%{name} #%{id}',
      empty: 'Список пуст.',
      invite: 'Хотите добавить?',
    },
    input: {
      file: {
        upload_several: 'Перетащите файлы сюда или нажмите для выбора.',
        upload_single: 'Перетащите файл сюда или нажмите для выбора.',
      },
      image: {
        upload_several: 'Перетащите изображения сюда или нажмите для выбора.',
        upload_single: 'Перетащите изображение сюда или нажмите для выбора.',
      },
      references: {
        all_missing: 'Невозможно найти связанные данные.',
        many_missing: 'Некоторые связанные данные недоступны.',
        single_missing: 'Связанные данные недоступны.',
      },
      password: {
        toggle_visible: 'Скрыть пароль',
        toggle_hidden: 'Показать пароль',
      },
    },
    message: {
      about: 'О программе',
      application_update_available: 'Доступна новая версия приложения.',
      are_you_sure: 'Вы уверены?',
      auth_error: 'Ошибка при проверке токена аутентификации.',
      bulk_delete_content: 'Вы уверены, что хотите удалить %{name}? |||| Вы уверены, что хотите удалить эти %{smart_count} элементов?',
      bulk_delete_title: 'Удалить %{name} |||| Удалить %{smart_count} %{name}',
      bulk_update_content: 'Вы уверены, что хотите обновить %{name}? |||| Вы уверены, что хотите обновить эти %{smart_count} элементов?',
      bulk_update_title: 'Обновить %{name} |||| Обновить %{smart_count} %{name}',
      clear_array_input: 'Вы уверены, что хотите очистить весь список?',
      delete_content: 'Вы уверены, что хотите удалить этот элемент?',
      delete_title: 'Удалить %{name} #%{id}',
      details: 'Подробности',
      error: 'Произошла ошибка клиента, и ваш запрос не может быть выполнен.',
      invalid_form: 'Форма недействительна. Пожалуйста, проверьте ошибки',
      loading: 'Страница загружается, пожалуйста подождите',
      no: 'Нет',
      not_found: 'Вы ввели неверный URL или перешли по неправильной ссылке.',
      yes: 'Да',
      unsaved_changes: 'Некоторые изменения не были сохранены. Вы уверены, что хотите их отменить?',
    },
    navigation: {
      no_results: 'Результаты не найдены',
      no_more_results: 'Страница %{page} выходит за пределы. Попробуйте предыдущую страницу.',
      page_out_of_boundaries: 'Страница %{page} выходит за пределы',
      page_out_from_end: 'Невозможно перейти дальше последней страницы',
      page_out_from_begin: 'Номер страницы не может быть меньше 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} из %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} из более чем %{total}',
      current_page: 'Страница %{page}',
      page: 'Перейти на страницу %{page}',
      first: 'Первая страница',
      last: 'Последняя страница',
      next: 'Следующая',
      previous: 'Предыдущая',
      page_rows_per_page: 'Строк на странице:',
      skip_nav: 'Перейти к содержимому',
    },
    sort: {
      sort_by: 'Сортировать по %{field} %{order}',
      ASC: 'по возрастанию',
      DESC: 'по убыванию',
    },
    auth: {
      auth_check_error: 'Пожалуйста, войдите в систему для продолжения',
      user_menu: 'Профиль',
      username: 'Имя пользователя',
      password: 'Пароль',
      sign_in: 'Войти',
      sign_in_error: 'Ошибка аутентификации, попробуйте снова',
      logout: 'Выйти',
    },
    notification: {
      updated: 'Элемент обновлен |||| %{smart_count} элементов обновлено',
      created: 'Элемент создан',
      deleted: 'Элемент удален |||| %{smart_count} элементов удалено',
      bad_item: 'Неверный элемент',
      item_doesnt_exist: 'Элемент не существует',
      http_error: 'Ошибка связи с сервером',
      data_provider_error: 'Ошибка провайдера данных. Проверьте консоль для деталей.',
      i18n_error: 'Невозможно загрузить переводы для указанного языка',
      canceled: 'Действие отменено',
      logged_out: 'Ваша сессия завершена, пожалуйста, переподключитесь.',
      not_authorized: 'Вы не авторизованы для доступа к этому ресурсу.',
    },
    validation: {
      required: 'Обязательное поле',
      minLength: 'Минимум %{min} символов',
      maxLength: 'Максимум %{max} символов',
      minValue: 'Минимум %{min}',
      maxValue: 'Максимум %{max}',
      number: 'Должно быть числом',
      email: 'Неверный email',
      oneOf: 'Должно быть одним из: %{options}',
      regex: 'Должно соответствовать формату (regexp): %{pattern}',
    },
    saved_queries: {
      label: 'Сохраненные запросы',
      query_name: 'Название запроса',
      new_label: 'Сохранить текущий запрос...',
      new_dialog_title: 'Сохранить текущий запрос как',
      remove_label: 'Удалить сохраненный запрос',
      remove_label_with_name: 'Удалить запрос "%{name}"',
      remove_dialog_title: 'Удалить сохраненный запрос?',
      remove_message: 'Вы уверены, что хотите удалить этот запрос из списка сохраненных?',
      help: 'Отфильтруйте список и сохраните запрос для последующего использования',
    },
    configurable: {
      customize: 'Настроить',
      configureMode: 'Настроить эту страницу',
      inspector: {
        title: 'Инспектор',
        content: 'Наведите на элементы интерфейса для их настройки',
        reset: 'Сбросить настройки',
        hideAll: 'Скрыть все',
        showAll: 'Показать все',
      },
      Datagrid: {
        title: 'Таблица',
        unlabeled: 'Столбец без названия #%{column}',
      },
      SimpleForm: {
        title: 'Форма',
        unlabeled: 'Поле без названия #%{input}',
      },
      SimpleList: {
        title: 'Список',
        primaryText: 'Основной текст',
        secondaryText: 'Дополнительный текст',
        tertiaryText: 'Третичный текст',
      },
    },
  },
  resources: {
    'telegram-products': {
      name: 'Telegram товар |||| Telegram товары',
      fields: {
        title: 'Название',
        description: 'Описание',
        price: 'Цена',
        photo: 'Фото',
        image: 'Изображение',
        category: 'Категория',
        createdAt: 'Дата создания',
        updatedAt: 'Дата обновления',
        postedInTelegram: 'Опубликовано в Telegram',
      },
    },
    'promo-codes': {
      name: 'Промокод |||| Промокоды',
      fields: {
        code: 'Код',
        discount: 'Скидка',
        discountType: 'Тип скидки',
        validFrom: 'Действует с',
        validTo: 'Действует до',
        usageLimit: 'Лимит использования',
        usedCount: 'Использовано',
        usageCount: 'Раз использовано',
        usageLimits: 'Лимиты использования',
        usageProgress: 'Прогресс использования',
        unlimited: 'Без ограничений',
        active: 'Активен',
        status: 'Статус',
        statusActive: 'Активен',
        statusExpiringSoon: 'Скоро истекает',
        statusExpired: 'Истёк',
        description: 'Описание',
        expiresAt: 'Истекает',
        percentageDiscount: 'Процентная скидка %',
        fixedDiscount: 'Фиксированная скидка',
        limitPerUser: 'Лимит на пользователя',
        expirationTime: 'Время истечения',
      },
    },
    'product-compositions': {
      name: 'Каталог',
      fields: {
        title: 'Название',
        description: 'Описание',
        price: 'Цена',
        available: 'В наличии',
        isAddon: 'Дополнение в корзине',
        photo: 'Фото',
        photos: 'Фотографии',
        postedToWix: 'Опубликовано в Wix',
        wixProductId: 'ID товара в Wix',
        onWix: 'В Wix',
        sku: 'Артикул',
        compositionItems: 'Товары',
        color: 'Цвет',
        amount: 'В наличии',
        rating: 'Рейтинг',
        reviewCount: 'Отзывы',
        orderCount: 'Заказы',
        labels: 'Метки',
        ingredients: 'Состав',
        customizationOptions: 'Опции кастомизации',
        inheritedOptions: 'Автоматически прилагается к этому букету',
        customizationOptionAdditions: 'Дополнительно только для этого букета',
        hideOnThisComposition: 'Скрыть',
        notOfferedOnThisComposition: 'Не предлагать для этого букета',
        relatedCompositionIds: 'Похожие товары',
      },
      helpers: {
        customizationOptions: 'Опции, которые увидит клиент при заказе этого букета.',
        noInheritedOptions:
          'Опции пока не привязаны. Добавьте метки выше, отметьте опции как глобальные или добавьте дополнения ниже.',
        customizationOptionAdditions:
          'Добавьте опцию только для этого букета, даже если его метки не совпадают.',
        prunedExclusions:
          '%{count} ранее скрытых опций больше недоступны и были очищены.',
      },
      actions: {
        manageCustomizationOptions: 'Перейти к опциям кастомизации →',
      },
    },
    'admin/catalog-labels': {
      name: 'Метка |||| Метки',
      fields: {
        name: 'Название',
        slug: 'Слаг',
        isActive: 'Активна',
        includeInactive: 'Показать неактивные',
        translations: 'Переводы',
      },
    },
    'attribute-definitions': {
      name: 'Свойство товара |||| Свойства товара',
    },
    'admin/customization-options': {
      name: 'Опция кастомизации |||| Опции кастомизации',
      fields: {
        name: 'Название',
        type: 'Тип',
        price: 'Цена',
        photo: 'URL фото',
        slug: 'Слаг',
        isActive: 'Активна',
        isGlobal: 'Глобальная',
        labelIds: 'Метки',
        includeInactive: 'Показать неактивные',
        translations: 'Переводы',
      },
      helpers: {
        photo: 'Необязательный URL изображения',
        slugAutoGenerate: 'оставьте пустым — сгенерируется из названия',
        isGlobal: 'Если включено, опция добавляется ко всем композициям независимо от меток.',
        labelIds: 'Привязать к композициям, у которых есть одна из этих меток.',
      },
      types: {
        wrapping: 'Обёртка',
        box: 'Коробка',
        ribbon: 'Лента',
        card: 'Открытка',
        other: 'Другое',
      },
    },
    products: {
      name: 'Склад',
      fields: {
        title: 'Название',
        description: 'Описание',
        price: 'Цена',
        color: 'Цвет',
        photo: 'Фото',
        amount: 'В наличии',
        categoryId: 'Категория',
        createdAt: 'Дата создания',
        availableAmount: 'Доступное количество',
        rating: 'Рейтинг',
        reviewCount: 'Отзывы',
        orderCount: 'Заказы',
        flowerTypes: 'Типы цветов',
        ingredients: 'Состав',
      },
    },
    categories: {
      name: 'Категория |||| Категории',
      fields: {
        name: 'Название',
        description: 'Описание',
        parentId: 'Родительская категория',
      },
    },
    'stock-movements': {
      name: 'Движение склада |||| Движения склада',
      fields: {
        productId: 'Товар',
        branchId: 'Филиал',
        quantity: 'Количество',
        type: 'Тип',
        reason: 'Причина',
        notes: 'Примечания',
        createdAt: 'Дата создания',
        date: 'Дата',
        dateFrom: 'Дата с',
        dateTo: 'Дата по',
        photo: 'Фото',
      },
    },
    'manual-orders': {
      name: 'Заказ |||| Заказы',
      fields: {
        orderNumber: 'Заказ №',
        customerName: 'Имя клиента',
        customerPhone: 'Телефон клиента',
        customerEmail: 'Email клиента',
        deliveryAddress: 'Адрес доставки',
        deliveryDate: 'Дата доставки',
        deliveryTime: 'Время доставки',
        status: 'Статус',
        totalAmount: 'Сумма',
        total: 'Итого',
        notes: 'Примечания',
        items: 'Товары',
        createdAt: 'Дата создания',
        branch: 'Филиал',
        fulfillmentType: 'Тип выполнения',
        fulfillment: 'Выполнение',
        fulfillmentDate: 'Дата выполнения',
        timeRange: 'Временной диапазон',
        timeFrom: 'Время с',
        timeTo: 'Время до',
        lead: 'Источник',
        leadContact: 'Контакт источника',
        recipientName: 'ФИО получателя',
        recipientPhone: 'Телефон получателя',
        recipientAddress: 'Адрес получателя',
        paymentMethod: 'Способ оплаты',
        comment: 'Комментарий',
        attachments: 'Вложения',
        products: 'Товары',
        clientId: 'Клиент',
        customRequest: 'Индивидуальный запрос',
        customBudget: 'Индивидуальный бюджет',
        paidAt: 'Оплата',
        paid: 'Оплачено',
        unpaid: 'Не оплачено',
        event: 'Событие',
      },
    },
    clients: {
      name: 'Клиент |||| Клиенты',
      fields: {
        source: 'Источник',
        name: 'Имя',
        phone: 'Телефон',
        email: 'Email',
        instagramHandle: 'Instagram Handle',
        telegramUsername: 'Telegram Username',
        notes: 'Заметки',
        branchId: 'Филиал',
        createdAt: 'Дата создания',
        updatedAt: 'Дата обновления',
        gender: 'Пол',
        birthday: 'Дата рождения',
        loyaltyTier: 'Уровень лояльности',
        bonusBalance: 'Бонусный баланс',
        orders: 'Заказы',
      },
    },
    users: {
      name: 'Пользователь |||| Пользователи',
      fields: {
        username: 'Имя пользователя',
        email: 'Email',
        password: 'Пароль',
        firstName: 'Имя',
        lastName: 'Фамилия',
        roles: 'Роли',
        role: 'Роль',
        active: 'Активен',
        createdAt: 'Дата создания',
        updatedAt: 'Дата обновления',
      },
    },
    roles: {
      name: 'Роль |||| Роли',
      fields: {
        name: 'Название',
        roleName: 'Название роли',
        description: 'Описание',
        permissions: 'Разрешения',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
      },
    },
    permissions: {
      name: 'Разрешение |||| Разрешения',
      fields: {
        name: 'Название',
        permissionName: 'Название разрешения',
        description: 'Описание',
        code: 'Код',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
      },
    },
    branches: {
      name: 'Филиал |||| Филиалы',
      fields: {
        name: 'Название',
        address: 'Адрес',
        phone: 'Телефон',
        email: 'Email',
        isActive: 'Активен',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
        hoursSchedule: 'Часы работы',
      },
      closed: 'Закрыто',
      open: 'Открытие',
      close: 'Закрытие',
      hoursSet: '7 дней',
      day: {
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
        sun: 'Вс',
      },
      validation: {
        openBeforeClose: 'Время открытия должно быть раньше времени закрытия для каждого рабочего дня.',
      },
    },
    'delivery-time-slots': {
      name: 'Временной слот доставки |||| Временные слоты доставки',
      fields: {
        key: 'Ключ',
        label: 'Название',
        startTime: 'Начало',
        endTime: 'Окончание',
        sortOrder: 'Порядок сортировки',
        isActive: 'Активен',
      },
      validation: {
        timeFormat: 'Время должно быть в формате ЧЧ:ММ (00:00 – 23:59).',
        startBeforeEnd: 'Время окончания должно быть позже времени начала.',
      },
    },
    'admin/settings': {
      name: 'Настройки',
      fields: {
        value: 'Значение',
      },
    },
    'mobile-orders': {
      name: 'Мобильный заказ |||| Мобильные заказы',
      fields: {
        status: 'Статус',
        deliveryMethod: 'Способ доставки',
        paymentMethod: 'Способ оплаты',
        total: 'Итого',
        clientId: 'Клиент',
        branchId: 'Филиал',
        deliveryDate: 'Дата доставки',
        deliveryTimeSlot: 'Время',
        giftMessage: 'Сообщение',
        promoCode: 'Промокод',
        notes: 'Заметки',
        subtotal: 'Подитог',
        deliveryFee: 'Стоимость доставки',
        discount: 'Скидка',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
        items: 'Товары',
        deliveryAddress: 'Адрес доставки',
        stripePaymentIntentId: 'Stripe Payment Intent',
      },
    },
    'loyalty-transactions': {
      name: 'Транзакция лояльности |||| Транзакции лояльности',
      fields: {
        type: 'Тип',
        amount: 'Сумма',
        description: 'Описание',
        clientId: 'Клиент',
        createdAt: 'Создано',
      },
    },
    campaigns: {
      name: 'Кампания |||| Кампании',
      fields: {
        title: 'Заголовок',
        subtitle: 'Подзаголовок',
        imageUrl: 'Изображение',
        currentImage: 'Текущее изображение',
        ctaLabel: 'Текст кнопки',
        linkType: 'Тип ссылки',
        linkTarget: 'Ссылка',
        backgroundColor: 'Цвет фона',
        isActive: 'Активна',
        startsAt: 'Начало',
        endsAt: 'Окончание',
        priority: 'Приоритет',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
      },
      linkType: {
        product: 'Товар',
        url: 'URL',
      },
      helpers: {
        selectLinkTypeFirst: 'Сначала выберите тип ссылки',
        uploadImage: 'Загрузить баннер',
        replaceImage: 'Заменить баннер',
        uploadAfterSave: 'Сначала сохраните кампанию, затем добавьте изображение.',
        hexColor: 'Hex-цвет, например #FDF2F8',
      },
      validation: {
        hexColor: 'Укажите hex-цвет, например #FDF2F8',
        url: 'Укажите корректный http(s) URL',
      },
    },
    events: {
      name: 'Событие |||| События',
      fields: {
        title: 'Заголовок',
        description: 'Описание',
        deliveryStartDate: 'Начало доставки',
        deliveryEndDate: 'Конец доставки',
        maxPerDay: 'Макс. заказов в день',
        branchId: 'Филиал',
        deliveryFee: 'Стоимость доставки',
        currency: 'Валюта',
        allowedCategoryIds: 'Разрешённые категории',
        allowedProductIds: 'Разрешённые букеты',
        contactPhone: 'Телефон получателя',
        contactData: 'Имя получателя',
        defaultAddress: 'Адрес доставки по умолчанию',
        isActive: 'Активно',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
      },
      sections: {
        pricing: 'Цены',
        catalogScope: 'Состав каталога',
        contact: 'Контакты и доставка',
      },
      helpers: {
        titleFallback: 'Чешский (основной) заголовок. Показывается чешским гостям и используется как запасной вариант для языков без перевода.',
        descriptionFallback: 'Чешское (основное) описание. Показывается чешским гостям и используется как запасной вариант для языков без перевода.',
        maxPerDay: 'Дата становится недоступной, когда на неё набрано столько заказов. По умолчанию 1.',
        branch: 'Филиал исполнения. Обязательно — гостевые заказы наследуют этот филиал.',
        deliveryFee: 'Добавляется к каждому заказу. Оставьте пустым, чтобы использовать глобальную настройку.',
        catalogScope:
          'Оставьте выбор букетов пустым, чтобы предложить все активные букеты каталога. Иначе гости увидят только выбранные букеты.',
        defaultAddress: 'Подставляется гостю, но может быть изменён при оформлении.',
      },
      copyLink: {
        sectionLabel: 'Гостевая ссылка',
        label: 'Публичный гостевой URL',
        helper: 'Закодируйте этот URL в QR-коде для события.',
        button: 'Скопировать ссылку',
        copied: 'Гостевая ссылка скопирована',
        copyFailed: 'Не удалось скопировать — выделите поле и скопируйте вручную.',
      },
    },
  },
  branches: {
    latitude: 'Широта',
    longitude: 'Долгота',
    latitudeHelper: "Откройте Google Maps, кликните правой кнопкой → 'Что здесь?' и скопируйте координаты. Диапазон от -90 до 90.",
    longitudeHelper: "Откройте Google Maps, кликните правой кнопкой → 'Что здесь?' и скопируйте координаты. Диапазон от -180 до 180.",
  },
  app: {
    language: 'Язык',
    branch: 'Филиал',
    allBranches: 'Все филиалы',
    search: 'Поиск',
    cancel: 'Отмена',
    back: 'Назад',
    add: 'Добавить',
    clear: 'Очистить',
    loading: 'Загрузка...',
    noResults: 'Ничего не найдено',
    actions: 'Действия',
    dashboard: {
      title: 'Главная',
      welcome: 'Добро пожаловать в панель администратора MoonFlowers',
      selectResource: 'Выберите раздел в меню для начала работы.',
      ordersAttention: 'Заказы, требующие внимания',
      noOrdersAttention: 'Все в порядке! Нет ожидающих заказов.',
      lowStock: 'Мало на складе',
      noLowStock: 'Все товары в достаточном количестве.',
      quickActions: 'Быстрые действия',
      newOrder: 'Новый заказ',
      newProduct: 'Новый товар',
      viewAnalytics: 'Аналитика',
      revenueLast7: 'Выручка за 7 дней',
    },
    menu: {
      dashboard: 'Главная',
      analytics: 'Аналитика',
      orders: 'Заказы',
      products: 'Товары',
      clients: 'Клиенты',
      channels: 'Каналы',
      settings: 'Настройки',
      catalog: 'Каталог',
      inventory: 'Склад',
      telegramBot: 'Telegram Бот',
      deliveries: 'Доставки',
      sales: 'Продажи',
      administration: 'Администрирование',
      dotykacka: 'Dotykacka',
      loyaltyScan: 'Сканер бонусов',
    },
    loyalty: {
      success: 'Бонусная операция записана',
      errors: {
        invalidAmount: 'Введите положительную сумму',
        insufficientBalance: 'Сумма превышает доступный бонусный баланс',
      },
      dialog: {
        title: 'Управление бонусами — %{name}',
        balance: 'Баланс',
        tier: 'Уровень',
        earn: 'Начислить',
        redeem: 'Списать',
        amount: 'Сумма (CZK)',
        orderId: 'ID заказа (опционально)',
        orderIdHelp: 'Привязка операции к заказу. Обязательно для проверки лимита и минимальной суммы.',
        description: 'Описание',
        confirmEarn: 'Начислить бонус',
        confirmRedeem: 'Списать бонус',
      },
      scan: {
        title: 'Сканер бонусов',
        subtitle: 'Отсканируйте QR клиента из мобильного приложения, чтобы найти его профиль и провести операцию.',
        cameraTitle: 'Камера QR',
        manualTitle: 'Ручной поиск',
        manualPlaceholder: 'Вставьте токен карты',
        lookup: 'Найти',
        start: 'Включить камеру',
        stop: 'Стоп',
        cameraError: 'Нет доступа к камере',
        empty: 'Отсканируйте QR или вставьте токен карты.',
        resultTitle: 'Клиент',
        recent: 'Последние операции',
        refresh: 'Обновить',
      },
    },
    analytics: {
      title: 'Аналитика',
      subtitle: 'Сводка за текущий месяц',
      ordersToday: 'Заказов сегодня',
      ordersYesterday: 'Заказов вчера',
      ordersThisWeek: 'На этой неделе',
      ordersThisMonth: 'В этом месяце',
      byStatus: 'Заказы по статусу',
      byLeadSource: 'Заказы по источнику',
      fulfillmentSplit: 'Самовывоз vs Доставка',
      revenueByBranch: 'Выручка по филиалам',
      noData: 'Заказов за выбранный период нет.',
      presetToday: 'Сегодня',
      presetWeek: 'Эта неделя',
      presetMonth: 'Этот месяц',
      presetLastMonth: 'Прошлый месяц',
      revenueTrend: 'Динамика выручки',
      byPaymentMethod: 'Заказы по способу оплаты',
      showRevenue: 'Выручка',
      showOrders: 'Заказы',
      rangeTotalOrders: 'Всего заказов',
      rangeTotalRevenue: 'Общая выручка',
      rangeAvgOrderPrice: 'Средний чек',
    },
    filters: {
      createdFrom: 'Создан от',
      createdTo: 'Создан до',
    },
    wix: {
      integration: 'Интеграция с Wix',
      currentStatus: 'Текущий статус:',
      publishedOnWix: 'Опубликовано в Wix',
      notPublished: 'Не опубликовано',
      wixProductId: 'ID товара в Wix',
      publishToWix: 'Опубликовать в Wix',
      toggleOffToUnpublish: 'Опубликовано в Wix (отключите для снятия публикации)',
      willBeVisible: 'Эта композиция будет видна в вашем магазине Wix. Все изменения будут синхронизироваться автоматически.',
      enableToPublish: 'Включите для публикации этой композиции в вашем магазине Wix.',
    },
    validation: {
      charactersLimit: '%{current}/%{max} символов',
      dateMustBeFuture: 'Дата должна быть сегодня или в будущем',
      maxCharacters: 'Максимум %{max} символов',
      duplicateProduct: 'Товар с таким названием уже существует',
      duplicateCategory: 'Категория с таким названием уже существует',
    },
    stock: {
      movement: 'Движение склада',
      in: 'Приход',
      out: 'Расход',
      supply: 'Поставка',
      writeOff: 'Списание',
      orderWriteOff: 'Списание по заказу',
      adjustment: 'Корректировка',
      uploadImage: 'Загрузить изображение (необязательно)',
      waste: {
        title: 'Неэффективные цветы',
        subtitle: 'Доля списаний в общем расходе — списания против расхода на заказы',
        rate: 'Уровень потерь',
        minNote: 'Товары с расходом от %{min} шт. за период',
        empty: 'Нет списаний за выбранный период',
      },
      batchIntake: {
        menuTitle: 'Массовый приход',
        title: 'Массовый приход товаров',
        subtitle: 'Быстрое добавление товаров на склад',
        addRow: 'Добавить товар',
        submit: 'Оформить приход',
        selectBranch: 'Сначала выберите филиал',
        addProducts: 'Добавьте хотя бы один товар с количеством',
        success: 'Создано %{count} движений склада',
        partialSuccess: '%{succeeded} успешно, %{failed} ошибок',
        reason: 'Массовый приход',
        preview: '%{count} товар(ов), %{total} единиц будет добавлено',
      },
    },
    order: {
      status: {
        todo: 'К выполнению',
        inProgress: 'В работе',
        ready: 'Готов',
        delivering: 'Доставляется',
        done: 'Выполнен',
        cancelled: 'Отменен',
      },
      statusEmoji: {
        todo: 'К выполнению',
        inProgress: 'В работе',
        ready: 'Готов',
        delivering: 'Доставляется',
        done: 'Выполнен',
        cancelled: 'Отменен',
      },
      newOrderStatus: 'Новые заказы всегда начинаются со статуса "К выполнению"',
      noComment: 'Без комментария',
      notSpecified: 'Не указано',
      noProducts: 'Нет товаров',
      noAttachments: 'Нет вложений',
      from: 'с',
      until: 'до',
      itemsSummary: 'Сводка по товарам:',
      productsInOrder: 'Товары в заказе *',
      searchProducts: 'Поиск товаров',
      typeToSearch: 'Введите для поиска или прокрутите...',
      outOfStock: 'Нет в наличии',
      available: '%{count} доступно',
      noProductsFound: 'Товары не найдены',
      noProductsAdded: 'Товары еще не добавлены. Найдите и добавьте товары выше.',
      calculatedTotal: 'Итого рассчитано:',
      qty: 'Кол-во',
      sum: 'Сумма',
      action: 'Действие',
      commentOptional: 'Комментарий (необязательно)',
      deliveryDetails: 'Детали доставки',
      leadInformation: 'Информация об источнике',
      orderStatus: 'Статус заказа',
      orderTotal: 'Итого по заказу',
      eventDetails: 'Детали события',
      payment: 'Оплата',
      uploadImages: 'Загрузить изображения (необязательно)',
      recipientAddressDelivery: 'Адрес получателя (для доставки)',
      searchClientsHint: 'Найдите существующих клиентов или оставьте пустым',
      notifications: {
        loadProductDetailsFailed: 'Не удалось загрузить данные о товарах',
        loadProductsFailed: 'Не удалось загрузить товары',
      },
    },
    fulfillment: {
      pickup: 'Самовывоз',
      delivery: 'Доставка',
    },
    paymentMethod: {
      notPaid: 'Не оплачено',
      raiffaisen: 'Raiffaisen',
      cash: 'Наличные',
      revolut: 'Revolut',
      uaCard: 'UA карта',
      crypto: 'Криптовалюта',
      paypal: 'PayPal',
      wise: 'Wise',
      iban: 'IBAN',
    },
    leadSource: {
      instagram: 'Instagram',
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      phone: 'Телефон',
      offline: 'Оффлайн',
      wolt: 'Wolt',
      website: 'Сайт',
      telegramBot: 'Telegram бот',
    },
    telegram: {
      postedInTelegram: 'Опубликовано в Telegram',
      toggleToPost: 'Переключите для публикации/удаления из Telegram канала',
      postToTg: 'Опубликовать в TG',
      unpostFromTg: 'Удалить из TG',
      inTg: 'В TG',
      currentImage: 'Текущее изображение',
      replaceImage: 'Заменить изображение',
      notifications: {
        posted: 'Опубликовано %{count} товар(ов) в Telegram',
        postError: 'Ошибка публикации товаров в Telegram',
        unposted: 'Снято с публикации %{count} товар(ов) из Telegram',
        unpostError: 'Ошибка снятия товаров с публикации в Telegram',
        invalidPercentage: 'Введите корректный процент',
        priceAdjusted: '%{action} цену для %{count} товар(ов) на %{percentage}%',
        priceAdjustError: 'Ошибка изменения цен',
      },
    },
    mobileOrder: {
      updateStatus: 'Обновить статус',
      status: {
        pending: 'Ожидает',
        confirmed: 'Подтвержден',
        preparing: 'Готовится',
        ready: 'Готов',
        delivering: 'Доставляется',
        delivered: 'Доставлен',
        cancelled: 'Отменен',
      },
      // D2.5 — кастомный букет
      customBouquet: {
        tag: 'СОБРАН',
        fallbackTitle: 'Собственный букет',
        tier: 'Тариф %{code}',
        stems: 'Стебли',
        stemsSubtotal: 'Подытог по стеблям',
        lineTotal: 'Линия',
        assembly: 'Сборка',
        customization: 'Кастомизация',
        customizationSubtotal: 'Подытог кастомизации',
        snapshotTotal: 'Итого по букету',
        snapshotMissing:
          'Снэпшот недоступен. Эндпоинт деталей заказа должен включать `customCompositions[%{id}]` для отображения полной информации.',
        wrap: 'Упаковка',
        ribbon: 'Лента',
        box: 'Коробка',
        card: 'Открытка',
        none: 'Нет',
      },
    },
    product: {
      currentPhoto: 'Текущее фото',
      replacePhoto: 'Заменить фото',
      uploadImage: 'Загрузить изображение (необязательно)',
      uploadPhotos: 'Загрузить фотографии',
      chooseColor: 'Выберите цвет или введите hex (например #FF3366)',
      hexColor: 'Hex цвет',
      removePhoto: 'Удалить фото',
      priceCZK: 'Цена (CZK)',
      availableAll: 'В наличии (Все)',
      availableBranch: 'В наличии (%{branch})',
      trackInventory: 'Учитывать на складе',
      trackInventoryHint: 'Отключите для позиций без реального остатка (доставка, услуги, упаковка).',
      notTracked: 'Не учитывается',
    },
    client: {
      source: {
        instagram: 'Instagram',
        telegram: 'Telegram',
        whatsapp: 'WhatsApp',
        mobile_phone: 'Мобильный телефон',
        offline: 'Оффлайн',
        wolt: 'Wolt',
        website: 'Сайт',
        telegram_bot: 'Telegram Бот',
      },
    },
    clientStats: {
      title: 'Метрики клиента',
      lifetimeValue: 'Общая ценность',
      totalOrders: 'Всего заказов',
      avgOrderValue: 'Средний чек',
      lastOrder: 'Последний заказ',
      favoriteSource: 'Предпочитаемый канал',
      churnRisk: {
        active: 'Активен',
        atRisk: 'Под угрозой',
        churned: 'Нужна реактивация',
        noOrders: 'Нет заказов',
      },
    },
    clientWishlist: {
      title: 'Избранное',
      product: 'Товар',
      price: 'Цена',
      savedAt: 'Сохранено',
      empty: 'Клиент еще не добавил товары в избранное.',
      deletedProduct: 'Товар удалён',
      loadError: 'Не удалось загрузить избранное',
    },
    referrals: {
      title: 'Рефералы',
      loadError: 'Не удалось загрузить рефералов',
      points: 'б.',
      status: {
        pending: 'Ожидание',
        settled: 'Засчитано',
        reversed: 'Отменено',
      },
      code: {
        label: 'Реферальный код',
        none: 'У клиента ещё нет реферального кода.',
        createdAt: 'Создан',
        disabledAt: 'Отключён',
        disabledLabel: 'Отключён',
        disable: 'Отключить',
        enable: 'Включить',
        disabled: 'Реферальный код отключён.',
        enabled: 'Реферальный код снова включён.',
        toggleFailure: 'Не удалось переключить состояние кода.',
      },
      asReferrer: {
        heading: 'Как реферер',
        empty: 'Этот клиент ещё не привёл ни одного реферала.',
      },
      asReferee: {
        heading: 'Как реферал',
        title: 'Приглашён клиентом',
        mintedPromo: 'Выданный промокод',
        promoUsed: 'использован',
        promoUnused: 'не использован',
      },
      columns: {
        referee: 'Реферал',
        appliedAt: 'Применён',
        status: 'Статус',
        qualifyingOrder: 'Зачётный заказ',
        unknownClient: 'Клиент удалён',
      },
      reverse: {
        button: 'Отменить',
        title: 'Ручная отмена реферала',
        explainer: 'Списывает 150 бонусных баллов у реферера и помечает атрибуцию как отменённую. Причина сохраняется на строке (с префиксом manual:) и в журнале действий администратора.',
        reasonLabel: 'Причина (обязательно)',
        reasonHelp: 'Минимум %{min} символов. Будет видна в журнале действий.',
        reasonTooShort: 'Причина должна быть не короче %{min} символов.',
        confirm: 'Отменить реферала',
        submitting: 'Отмена...',
        success: 'Реферал отменён, 150 баллов списано.',
        failure: 'Не удалось отменить реферала.',
      },
    },
    composition: {
      skuAutoGenerated: 'Уникальный артикул будет сгенерирован автоматически',
      skuHint: 'Уникальный идентификатор, синхронизируемый на всех платформах',
      amountCalculated: 'Рассчитывается автоматически из товаров композиции',
      isAddonHelp: 'Показывает этот товар в корзине в блоке «Добавьте что-нибудь ещё» вместо обычного каталога (шоколад, шары, открытки, вазы).',
      products: 'Товары в композиции',
      searchProducts: 'Найти товары для добавления...',
      noProducts: 'Товары ещё не добавлены',
      productsCount: '%{count} товар(ов)',
      generateContent: 'Сгенерировать с ИИ',
      regenerateContent: 'Сгенерировать заново',
      generating: 'Генерация...',
      generateError: 'Не удалось сгенерировать контент. Попробуйте ещё раз.',
      generateNoPhotos: 'Сначала загрузите фотографии для генерации контента',
      generateHint: 'ИИ проанализирует ваши фотографии и предложит название и описание',
      saveFirstToGenerate: 'Сначала сохраните композицию с фотографиями, затем используйте ИИ для генерации контента',
      priceAutoComputed: 'Рассчитывается автоматически по товарам',
      priceOverridden: 'Изменено вручную',
      resetToComputed: 'Вернуть расчётную цену',
    },
    category: {
      categoryName: 'Название категории',
    },
    promo: {
      description: 'Описание промокода',
      promoCode: 'Промокод',
    },
    user: {
      autoGeneratedPassword: 'Автоматически сгенерированный пароль. Вы можете изменить его при необходимости.',
      leaveEmptyPassword: 'Оставьте пустым, чтобы сохранить текущий пароль',
    },
    bulk: {
      increasePrice: 'Увеличить цену',
      decreasePrice: 'Уменьшить цену',
      increase: 'Увеличить',
      decrease: 'Уменьшить',
      percentage: 'Процент',
      changeStatus: 'Изменить статус (%{count})',
      statusUpdated: 'Обновлено %{count} заказов на статус "%{status}"',
      statusUpdateFailed: 'Не удалось обновить некоторые заказы',
      statusUpdateSingleFailed: 'Не удалось обновить статус',
    },
    migration: {
      importProducts: 'Импорт товаров из Dotykacka CSV',
      importCategories: 'Импорт категорий из Dotykacka CSV',
      uploadCsv: 'Загрузить CSV',
      importButton: 'Импортировать %{count} товаров',
      importCategoriesButton: 'Импортировать %{count} категорий',
      importing: 'Импортирование...',
      importCompleted: 'Импорт завершен: %{success} товаров успешно импортировано',
      importCategoriesCompleted: 'Импорт завершен: %{success} категорий успешно импортировано',
      failed: '%{count} не удалось',
      encoding: 'Кодировка',
      utf8: 'UTF-8',
      windows1250: 'Windows-1250 (Чешская)',
      productsDescription: 'Загрузите CSV файл со столбцами: name (название товара), priceWithVAT (цена), и опционально categoryName (будет сопоставлено с существующими категориями). Количество будет установлено в 0.',
      categoriesDescription: 'Загрузите CSV файл со столбцом: name (название категории).',
      notFound: 'не найдено',
      number: '№',
      name: 'Название',
      amount: 'Количество',
    },
    board: {
      listView: 'Табличный вид',
      boardView: 'Доска',
      noOrders: 'Нет заказов',
      today: 'Сегодня',
      tomorrow: 'Завтра',
      weddingEvent: 'Свадебное событие',
      subtitle: '%{count} активных заказов',
      moveTo: 'Переместить в',
    },
    telegramBot: {
      title: 'Telegram Бот',
      subtitle: 'Управление интеграцией Telegram бота',
      totalProducts: 'Всего товаров',
      activeProducts: 'Активных товаров',
      totalOrders: 'Всего заказов',
      completedOrders: 'Завершённые',
      inProgressOrders: 'В процессе',
      failedOrders: 'Неудачные',
      broadcastTitle: 'Рассылка сообщений',
      broadcastHint: 'Отправьте сообщение всем пользователям Telegram бота одновременно.',
      broadcastPlaceholder: 'Введите сообщение для рассылки всем пользователям бота...',
      sendBroadcast: 'Отправить рассылку',
      sending: 'Отправка...',
      broadcastSuccess: 'Сообщение отправлено успешно',
      broadcastError: 'Не удалось отправить рассылку',
      recentProducts: 'Последние товары бота',
      posted: 'Опубликован',
      notPosted: 'Не опубликован',
      noProducts: 'В боте пока нет товаров',
    },
    delivery: {
      title: 'Доска доставок',
      subtitle: 'Управление доставками на',
      toPrepare: 'К подготовке',
      outForDelivery: 'В доставке',
      completed: 'Завершены',
      completedToday: 'Завершены сегодня',
      noDeliveries: 'Нет доставок на эту дату',
      markReady: 'Готов',
      markDelivering: 'Начать доставку',
      markDone: 'Завершить',
      recipient: 'Получатель',
      address: 'Адрес',
      timeSlot: 'Время',
      today: 'Сегодня',
      total: 'Всего',
      remaining: 'Осталось',
      notifications: {
        loadFailed: 'Не удалось загрузить доставки',
        statusUpdated: 'Статус обновлен',
        statusUpdateFailed: 'Не удалось обновить статус',
      },
    },
    translations: {
      title: 'Переводы',
      cs: 'Чешский',
      en: 'Английский',
      ua: 'Украинский',
      ru: 'Русский',
    },
    ai: {
      generate: 'Сгенерировать с ИИ',
      regenerate: 'Сгенерировать заново',
      generating: 'Генерация...',
      error: 'Не удалось сгенерировать. Попробуйте ещё раз.',
      generateTitle: 'Сгенерировать название с ИИ',
      regenerateTitle: 'Перегенерировать название',
      generateDescription: 'Сгенерировать описание с ИИ',
      regenerateDescription: 'Перегенерировать описание',
      productTitleHint: 'ИИ предложит название по фото, текущему названию и категории.',
      productDescriptionHint: 'ИИ предложит описание по названию, фото и категории.',
      productTitleDisabled: 'Добавьте фото или текущее название для генерации.',
      productDescriptionDisabled: 'Добавьте название или фото для генерации.',
    },
    advancedAnalytics: {
      title: 'Расширенная аналитика',
      products: 'Эффективность товаров',
      customers: 'Анализ клиентов',
      seasonal: 'Сезонные тренды',
      topProducts: 'Топ товаров по выручке',
      productName: 'Товар',
      unitsSold: 'Продано',
      revenue: 'Выручка',
      newCustomers: 'Новые клиенты',
      returningCustomers: 'Возвращающиеся клиенты',
      topCustomers: 'Топ клиентов',
      customerName: 'Клиент',
      orders: 'Заказы',
      monthlyRevenue: 'Ежемесячная выручка (за 12 месяцев)',
    },
    common: {
      created: 'Создано',
      updated: 'Обновлено',
      searchByTitle: 'Поиск по названию',
    },
    settings: {
      deliveryFee: 'Стоимость доставки (CZK)',
      lastUpdated: 'Последнее обновление: %{date}',
      saved: 'Сохранено',
    },
    bouquetBuilder: {
      title: 'Настройки конструктора букета',
      menu: 'Конструктор букета',
      enabled: 'Конструктор включён',
      enabledHint:
        'Главный переключатель. При выключении экран конструктора и плитка в каталоге скрыты.',
      live: 'Включён',
      off: 'Выключен',
      minOrderTitle: 'Минимальная сумма заказа',
      minOrderInvalid: 'Минимальная сумма должна быть целым неотрицательным числом',
      tiersTitle: 'Размерные уровни (диапазоны стеблей + сбор за сборку)',
      tiersHint:
        'Уровни должны покрывать 1..∞ без пропусков. Только последний уровень может иметь ∞ макс. стеблей.',
      saved: 'Настройки конструктора сохранены',
      lastUpdated: 'Последнее обновление: %{date}',
      tier: {
        code: 'Код',
        minStems: 'Мин. стеблей',
        maxStems: 'Макс. стеблей',
        feeKc: 'Сбор (CZK)',
        add: 'Добавить уровень',
        infinityHint: 'Переключить ∞ (без верхней границы) для последнего уровня',
      },
      category: {
        title: 'Категории — переводы + фото',
        slug: 'Внутреннее имя',
        image: 'Фото-заглушка',
        noImage: 'Нет изображения',
        titles: 'Названия по локалям',
        uploadButton: 'Загрузить изображение',
        uploadHint: 'JPG/PNG, ≤ 5 МБ',
        uploadPending:
          'Загрузка изображения недоступна — нужна доработка backend (столбец + endpoint)',
        uploadOk: 'Изображение загружено',
        saved: 'Категории сохранены',
        nothingChanged: 'Нет изменений в категориях',
        missingCs: 'Чешское (cs) название обязательно для: ',
        empty: "Не найдено категорий 'Flowers –%'. Проверьте соглашение об именах.",
        dirty: '%{n} несохранённых',
        clean: 'Все изменения сохранены',
        backendPending:
          'Загрузка картинок и сохранение переводов требуют доработки backend: (1) применить миграцию 20260524120000 (categories.image_url), (2) расширить UpdateCategoryDto, разрешив поля `translations` и `image_url`, (3) добавить POST /categories/:id/image (multipart) по аналогии с campaigns.',
      },
    },
  },
};

export default russianMessages;
